<template>
  <div v-if="hasData" class="infostealers-keywords-widget">
    <div class="infostealers-keywords-widget__title">
      {{this.$t(title)}}
    </div>
    <v-divider />
    <div class="infostealers-keywords-widget__data">
      <div class="infostealers-keywords-widget__data__scroll-container">
        <div v-for='(keyword, i) in sortedList' class='infostealers-keywords-widget__data__row' :key='`infostealers-keywords-widget__data__row-${i}`'>
          <div class='infostealers-keywords-widget__data__row__keyword' v-html='keyword.name' />
          <div class='infostealers-keywords-widget__data__row__state' v-html='keyword.state' />
          <div class='infostealers-keywords-widget__data__row__amount' v-html='keyword.amount' />
          <div class='infostealers-keywords-widget__data__row__progress'>
            <span :class="{ready: keyword.progressValue === 100}" class="percent">{{ keyword.progressPercentage }}</span>
            <project-spinner-progress v-if='keyword.progressValue != 100' :progress='keyword.progressValue' :color="keyword.progressValue === 100 ? '#2459D5' : '#56C228'"/>
            <circle-progress v-else :progress='keyword.progressValue' :color="keyword.progressValue === 100 ? '#2459D5' : '#56C228'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectSpinnerProgress from '@/components/common/ProjectSpinnerProgress.vue';
import CircleProgress from '@/components/common/CircleProgress.vue';

export default {
  name: 'InfostealersKeywordsWidget',
  components: {
    ProjectSpinnerProgress,
    CircleProgress,
  },
  props: {
    keywords: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    title() {
      return 'infostealers.keywords.widget.title';
    },
    sortedList() {
      return [...this.keywords]
        .sort((a, b) => b.progressValue - a.progressValue);
    },
    hasData() {
      return this.sortedList.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.infostealers-keywords-widget {
  min-width: rem(500);
  max-width: rem(500);
  min-height: rem(120);
  max-height: rem(150);
  display: flex;
  flex-direction: column;
  border-radius: $radius-md;
  background-color: var(--bg-secondary);
  padding-bottom: $space-4;

  &__title {
    color: var(--text-secondary);
    font-family: $font-family-regular;
    font-size: $font-size-sm;
    padding: rem(20) rem(25) 0;
    text-transform: uppercase;
    margin-bottom: rem(7);
    letter-spacing: 1.1px;
    line-height: rem(15);
  }

  &__data {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-height: rem(85);
    margin-left: rem(25);
    margin-right: rem(25);
    margin-bottom: $space-4;

    &__scroll-container {
      display: flex;
      flex-direction: column;
      max-height: rem(85);
      overflow-y: auto;
      padding-right: $space-2;
      padding-bottom: $space-1;

      &::-webkit-scrollbar {
        width: rem(6);
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: $radius-sm;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }

    &__row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: $space-3 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      &:last-child {
        border-bottom: none;
      }

      &__keyword {
        font-family: $font-family-bold;
        font-size: $font-size-base;
        color: var(--text-primary);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: rem(125);
        max-width: rem(125);
        line-height: 1.6;
      }

      &__state {
        font-family: $font-family-semibold;
        font-size: $font-size-sm;
        color: var(--text-secondary);
        line-height: 1.6;
        text-align: center;
        white-space: nowrap;
        min-width: rem(70);
        max-width: rem(70);
        margin: 0 $space-2;
      }

      &__progress {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: rem(100);
        max-width: rem(100);

        .percent {
          display: inline-block;
          font-family: $font-family-bold;
          font-size: $font-size-base;
          color: #56C228;
          margin-right: $space-2;
        }

        .ready {
          color: #2459D5;
        }

        .project-spinner-progress {
          display: inline-block;
          width: rem(20);
          height: rem(20);
        }

        .circle-progress {
          display: inline-block;
          width: rem(20);
          height: rem(20);
        }
      }

      &__amount {
        font-family: $font-family-semibold;
        font-size: $font-size-sm;
        color: var(--text-secondary);
        line-height: 1.6;
        text-align: right;
        white-space: nowrap;
        min-width: rem(100);
        max-width: rem(100);
        margin-left: $space-2;
      }
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.infostealers-keywords-widget {
  .v-divider {
    margin-left: rem(25) !important;
    margin-right: rem(25) !important;
    margin-bottom: $space-4;
  }
}
</style>
